import { ILocation, IViewLocation, IViewLocations } from 'src/interfaces';
import { checkByKeywords } from 'src/utils';

export const filterLocations = (
  locations: IViewLocation[],
  filter: Record<string, string[]>,
): IViewLocation[] => {
  if (filter['name.regexp']) {
    const keywords = filter['name.regexp'];

    return locations.filter((location) => {
      return (
        checkByKeywords(keywords, location.hq.name) ||
        checkByKeywords(keywords, location.hq.region) ||
        checkByKeywords(keywords, location.hq.store_number)
      );
    });
  }

  return locations;
};

export const getViewLocationGroupFromID = (
  viewLocationGroupData: IViewLocations | undefined,
  locationGroupId: number,
) =>
  viewLocationGroupData?.locationGroups.find(
    (locationGroup) => locationGroup.id === locationGroupId,
  );

export const addOrReplaceLocationGroupID = (
  location: ILocation,
  currentLocationGroupId: number,
  viewLocationGroupData: IViewLocations | undefined,
) => {
  const currentLocationGroup = getViewLocationGroupFromID(
    viewLocationGroupData,
    currentLocationGroupId,
  );
  // Check if there is any location group with the same channel name and type that is default
  const defaultLocationGroupWithSameChannel = location.location_group_id.find(
    (groupId) => {
      const locationGroup = getViewLocationGroupFromID(
        viewLocationGroupData,
        groupId,
      );

      return (
        locationGroup?.is_default &&
        locationGroup?.layout_type_id ===
          currentLocationGroup?.layout_type_id &&
        locationGroup?.channel_name === currentLocationGroup?.channel_name
      );
    },
  );

  // replace the matching default location group with the current location group
  if (defaultLocationGroupWithSameChannel) {
    return location.location_group_id.map((groupId) => {
      const locationGroup = getViewLocationGroupFromID(
        viewLocationGroupData,
        groupId,
      );
      if (
        locationGroup?.channel_name === currentLocationGroup?.channel_name &&
        locationGroup?.is_default
      ) {
        return currentLocationGroupId;
      }

      return groupId;
    });
  }

  // if there is no matching default location group to replace, add the new locationGroupID to the list
  return [...location.location_group_id, currentLocationGroupId];
};
